import { Platform } from 'react-native'
import { TypographyVariant } from '@ui/typography/types'
import { TileBlurVariant } from './types'

export const titleVariantMap: Record<TileBlurVariant, TypographyVariant> = {
  large: 'H5',
  default: 'LGB',
  option: 'LGB',
  small: 'LGB',
}

export const descVariantMap: Record<TileBlurVariant, TypographyVariant> = {
  large: Platform.select({ default: 'SM', web: 'MD' }),
  default: Platform.select({ default: 'SM', web: 'MD' }),
  option: Platform.select({ default: 'SM', web: 'MD' }),
  small: Platform.select({ default: 'SM', web: 'MD' }),
}

export const padding: Record<TileBlurVariant, string> = {
  large: Platform.select({ default: 'p-8', web: 'p-8' }),
  default: Platform.select({ default: 'p-8', web: 'p-8' }),
  option: Platform.select({ default: 'pt-6 pb-8 px-8', web: 'p-8' }),
  small: Platform.select({ default: 'p-8', web: 'p-8 pr-0' }),
}

export const sInner: Record<TileBlurVariant, string> = {
  large: Platform.select({ default: 'gap-4', web: 'gap-6' }),
  default: Platform.select({ default: 'gap-4', web: 'gap-4' }),
  option: Platform.select({ default: 'gap-4', web: 'gap-4' }),
  small: Platform.select({ default: 'gap-4', web: 'gap-4' }),
}
